const AboutUs = () => {
    return (
        <div className="page">
            <h1>About Us</h1>
            <p>Invoice3 is a decentralized invoice payment system built on the Ethereum blockchain.</p>
            <p>Invoice3 is a project developed for the ETHWarsaw 2023 hackathon.</p>
            <p>Invoice3 is developed by the following team:</p>
            <ul>
                <li>Alexandre GROS</li>
                <li>Edouard GUILLERMAIN</li>
                <li>Lucas KACZMARSKI</li>
                <li>Sunil GOULAMHOUSSEN</li>
            </ul>
        </div>   
    )
}

export default AboutUs;